<template>
  <div>

    <h1>About {{ count }}</h1>
  </div>
</template>

<script>



import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {},
  computed: {
    ...mapState({
      count: state => state.count
    })
  },
  methods: {
    increment() {
      this.$store.dispatch('increment');
    }
  },
  created() {
    console.log('Home component created, count:', this.count);
  },
  updated() {
    console.log('Home component updated, count:', this.count);
  }
};
</script>
